import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import RecurringGiftCard from './RecurringGiftCard';

export default function RecurringGiftList({ gifts = [], funds = [], onUpdate, testID = 'recurring-gift-list' }) {
    if (gifts.length === 0) {
        return (
            <View style={styles.empty} testID={`${testID}-empty`}>
                <Text style={styles.emptyText}>No recurring gifts yet.</Text>
            </View>
        );
    }

    return (
        <View style={styles.container} testID={testID}>
            {gifts.map((gift) => (
                <RecurringGiftCard
                    key={gift.id}
                    gift={gift}
                    funds={funds}
                    onUpdate={onUpdate}
                    testID={`${testID}-gift-${gift.id}`}
                />
            ))}
        </View>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, typography }) => ({
    container: {
        gap: spacing.md,
    },
    empty: {
        paddingVertical: spacing.xl,
        alignItems: 'center',
    },
    emptyText: {
        fontSize: typography.body,
        fontFamily: fonts.body,
        color: colors.textSecondary,
    },
}));
